export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.base.alfamall";

export const APP_STORE_URL =
  "https://apps.apple.com/us/app/alfamall/id6748519089";

const ANDROID_PACKAGE = "com.base.alfamall";

export const GET_APP_LABEL = "Get AlfaMall App";
export const SCAN_TO_DOWNLOAD_LABEL = "Scan to download";
export const OPEN_APP_LABEL = "Open app";
export const CONTINUE_IN_BROWSER_LABEL = "Not now, continue in browser";
export const EXPLORE_IN_APP_LABEL = "Explore www.alfamall.com in...";
export const APP_NAME = "AlfaMall app";
export const DISMISS_STORAGE_KEY = "alfamallAppPromptDismissed";
export const APP_PROMPT_DELAY_MS = 15000;

const HIDDEN_APP_PROMPT_PATHS = [
  "/cart/checkout",
  "/login",
  "/password-protected",
  "/islamic-12-12",
  "/vertica",
];

export function isAppPromptHidden(pathname = "") {
  return HIDDEN_APP_PROMPT_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`),
  );
}

function isIosDevice() {
  const userAgent = navigator.userAgent || "";
  const iOSDevice = /iPad|iPhone|iPod/.test(userAgent);
  const iPadOS =
    navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;

  return iOSDevice || iPadOS;
}

const APP_SCHEME = "alfamall";
const APP_SCHEME_URL = `${APP_SCHEME}://`;
const IOS_STORE_FALLBACK_MS = 2500;

function openIosApp() {
  const openedAt = Date.now();

  const cleanup = () => {
    window.clearTimeout(timer);
    document.removeEventListener("visibilitychange", onHidden);
    window.removeEventListener("pagehide", cleanup);
  };

  const onHidden = () => {
    if (document.hidden) cleanup();
  };

  // Timers are throttled while the app is in front, so a late fire means the app opened.
  const timer = window.setTimeout(() => {
    cleanup();
    if (document.hidden) return;
    if (Date.now() - openedAt > IOS_STORE_FALLBACK_MS + 1000) return;
    window.location.href = APP_STORE_URL;
  }, IOS_STORE_FALLBACK_MS);

  document.addEventListener("visibilitychange", onHidden);
  window.addEventListener("pagehide", cleanup);
  window.location.href = APP_SCHEME_URL;
}

function openAndroidApp() {
  const fallbackUrl = encodeURIComponent(PLAY_STORE_URL);
  window.location.href = `intent://open#Intent;scheme=${APP_SCHEME};package=${ANDROID_PACKAGE};S.browser_fallback_url=${fallbackUrl};end`;
}

export function openApp() {
  if (isIosDevice()) {
    openIosApp();
    return;
  }

  openAndroidApp();
}

export function rememberAppPromptDismissed() {
  sessionStorage.setItem(DISMISS_STORAGE_KEY, "1");
}

export function isAppPromptDismissed() {
  return sessionStorage.getItem(DISMISS_STORAGE_KEY) === "1";
}
